import axios from "axios";

// CHANGE THIS to your production base URL when ready
export const TAX_API_BASE = "https://www.bordertax.taxisafar.com/api";
export const EMPLOYEE_AUTH_API_BASE = "https://authapi.taxisafar.com/api/v1/role";
export const AUTH_API = "https://authapi.taxisafar.com";

// Tax API
const api = axios.create({
  baseURL: TAX_API_BASE,
});

// Auth API
export const authApi = axios.create({
  baseURL: AUTH_API,
});

// Common request interceptor
const requestInterceptor = (config) => {
  const token = localStorage.getItem("employeeToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// Common response interceptor
const responseInterceptor = (res) => res;

const errorInterceptor = (err) => {
  if (err.response?.status === 401) {
    localStorage.removeItem("employeeToken");
    localStorage.removeItem("employee");
    window.location.href = "/login";
  }
  return Promise.reject(err);
};

api.interceptors.request.use(requestInterceptor);
authApi.interceptors.request.use(requestInterceptor);

api.interceptors.response.use(responseInterceptor, errorInterceptor);
authApi.interceptors.response.use(responseInterceptor, errorInterceptor);

export default api;